var pt = {
	"neptune.Button.loadingAriaLabel": "carregando",
	"neptune.Chips.ariaLabel": "Remover {choice}",
	"neptune.ClearButton.ariaLabel": "Remover",
	"neptune.CloseButton.ariaLabel": "Fechar",
	"neptune.DateInput.day.label": "Dia",
	"neptune.DateInput.day.placeholder": "DD",
	"neptune.DateInput.month.label": "Mês",
	"neptune.DateInput.year.label": "Ano",
	"neptune.DateInput.year.placeholder": "AAAA",
	"neptune.DateLookup.day": "dia",
	"neptune.DateLookup.goTo20YearView": "Acessar a visualização de 20 anos",
	"neptune.DateLookup.month": "mês",
	"neptune.DateLookup.next": "próximo",
	"neptune.DateLookup.previous": "anterior",
	"neptune.DateLookup.selected": "selecionada",
	"neptune.DateLookup.twentyYears": "20 anos",
	"neptune.DateLookup.year": "ano",
	"neptune.FlowNavigation.back": "voltar à etapa anterior",
	"neptune.Info.ariaLabel": "Mais informações",
	"neptune.Label.optional": "(Opcional)",
	"neptune.Link.opensInNewTab": "(abre em uma nova aba)",
	"neptune.MoneyInput.Select.placeholder": "Escolha uma opção...",
	"neptune.MoneyInput.Select.selectCurrencyLabel": "Selecione a moeda",
	"neptune.PhoneNumberInput.SelectInput.placeholder": "Escolha uma opção...",
	"neptune.Select.searchPlaceholder": "Buscar...",
	"neptune.SelectInput.noResultsFound": "Nenhum resultado encontrado",
	"neptune.SelectOption.action.label": "Selecionar",
	"neptune.SelectOption.selected.action.label": "Altere a opção escolhida",
	"neptune.StatusIcon.iconLabel.error": "Erro:",
	"neptune.StatusIcon.iconLabel.information": "Informação:",
	"neptune.StatusIcon.iconLabel.pending": "Pendente:",
	"neptune.StatusIcon.iconLabel.success": "Concluído:",
	"neptune.StatusIcon.iconLabel.warning": "Aviso:",
	"neptune.Summary.statusDone": "Pronto",
	"neptune.Summary.statusNotDone": "Não iniciado",
	"neptune.Summary.statusPending": "Pendente",
	"neptune.Table.actionHeader": "Ação",
	"neptune.Table.emptyData": "Nenhum resultado encontrado",
	"neptune.Table.loaded": "Os dados da tabela foram carregados",
	"neptune.Table.loading": "Os dados da tabela estão sendo carregados",
	"neptune.Table.refreshPage": "Atualizar página",
	"neptune.Upload.csButtonText": "Enviar outro documento?",
	"neptune.Upload.csFailureText": "Falha no envio. Por favor, tente novamente",
	"neptune.Upload.csSuccessText": "Envio concluído!",
	"neptune.Upload.csTooLargeMessage": "Por favor, envie um arquivo com menos de {maxSize}MB",
	"neptune.Upload.csWrongTypeMessage": "Não trabalhamos com este tipo de arquivo. Por favor, tente novamente com um arquivo diferente",
	"neptune.Upload.psButtonText": "Cancelar",
	"neptune.Upload.psProcessingText": "Enviando...",
	"neptune.Upload.retry": "Tente novamente",
	"neptune.Upload.usButtonText": "Ou escolha um arquivo",
	"neptune.Upload.usDropMessage": "Arraste o arquivo para iniciar o envio",
	"neptune.Upload.usPlaceholder": "Selecione e envie um arquivo com menos de {maxSize}MB",
	"neptune.UploadButton.allFileTypes": "Todos os tipos de arquivos",
	"neptune.UploadButton.dropFiles": "Arraste o arquivo para iniciar o envio",
	"neptune.UploadButton.instructions": "{fileTypes}, com menos de {size}MB",
	"neptune.UploadButton.maximumFiles": "Máximo de {maxFiles} arquivos.",
	"neptune.UploadButton.uploadFile": "Enviar arquivo",
	"neptune.UploadButton.uploadFiles": "Enviar arquivos",
	"neptune.UploadInput.deleteModalBody": "Se você remover este arquivo, ele será permanentemente excluído do nosso sistema.",
	"neptune.UploadInput.deleteModalCancelButtonText": "Cancelar",
	"neptune.UploadInput.deleteModalConfirmButtonText": "Remover",
	"neptune.UploadInput.deleteModalTitle": "Tem certeza que deseja remover esta arquivo?",
	"neptune.UploadInput.fileIsTooLarge": "O arquivo é muito grande",
	"neptune.UploadInput.fileTypeNotSupported": "Não aceitamos arquivos neste formato",
	"neptune.UploadInput.maximumFilesAlreadyUploaded": "Não recebemos os seus arquivos. Você só pode enviar {maxFilesAllowed} arquivos por vez.",
	"neptune.UploadItem.deleting": "Removendo...",
	"neptune.UploadItem.removeFile": "Remover arquivo {filename}",
	"neptune.UploadItem.uploaded": "Enviado",
	"neptune.UploadItem.uploadedFile": "Arquivo enviado",
	"neptune.UploadItem.uploading": "Enviando...",
	"neptune.UploadItem.uploadingFailed": "Falha no envio"
};

export { pt as default };
//# sourceMappingURL=pt.json.mjs.map
